import { Component, Input } from '@angular/core';
import { Company } from 'src/app/models/data/company';
import { ApiService, QueryParam } from 'src/app/services/api.services';
import { SubNavComponent } from '../../../../components/sub-nav/sub-nav.component';
import { SubNavTabDirective } from '../../../../components/sub-nav/sub-nav-tab.directive';
import { BreadcrumbLabelDirective } from '../../../../directives/breadcrumb-label.directive';
import { AllDevicesComponent } from '../../../device/main/all-devices/all-devices.component';
import { DeviceGroupsComponent } from '../../../device/main/device-groups/device-groups.component';

@Component({
	selector: 'app-company-device-tabs',
	imports: [
		SubNavComponent,
		SubNavTabDirective,
		BreadcrumbLabelDirective,
		AllDevicesComponent,
		DeviceGroupsComponent,
	],
	templateUrl: './company-device-tabs.component.html',
})
export class CompanyDeviceTabsComponent {
	@Input() companyId?: string;
	@Input() company?: Company;
	/** Oracle list writes for the route company; false for Support/Billing. */
	@Input() canWrite = false;
	@Input() breadcrumbLabel = '';

	readonly deviceDataRequest = (filter: QueryParam[]) =>
		this.apiService.getDevicesByCompanyId(this.companyId!, filter);

	constructor(private readonly apiService: ApiService) {}
}
